import { useMemo } from 'react';

import { TaxChartContextProvider } from '../../TaxDiagram/TaxChartContext';
import type { StructureChartProviderProps } from '../adapters';

// Change shape needs the company, and stays off in offscreen captures.
const TaxStructureProvider = ({
  companyId,
  isInteractive,
  children,
}: StructureChartProviderProps) => {
  const value = useMemo(
    () => ({ companyId, canOverride: isInteractive }),
    [companyId, isInteractive]
  );
  return (
    <TaxChartContextProvider value={value}>{children}</TaxChartContextProvider>
  );
};

export { TaxStructureProvider };
